/* eslint-disable @typescript-eslint/no-unused-vars */
import { MergeFieldData, useGetMergeFields } from '@fluentsms/fluent-client-documents';
import React from 'react';

function sortMergeFieldsByCategory(mf1: MergeFieldData, mf2: MergeFieldData): number {
  if (mf1.category !== mf2.category) {
    return (mf1.category as string).localeCompare(mf2.category as string);
  } else {
    return (mf1.label as string).localeCompare(mf2.label as string);
  }
}

/**
 * Fetch the merge fields available for the current tenant
 * @param _ignored - DEPRECATED: this argument is no longer required
 * @returns { mergeFields: MergeFieldData[], loading: boolean }
 */
// eslint-disable-next-line @typescript-eslint/no-unused-vars
export const useMergeFields = (
  /** @deprecated orgId is no longer required */
  _ignored?: unknown,
): { mergeFields: MergeFieldData[]; loading: boolean } => {
  const { data, loading } = useGetMergeFields(undefined);

  const mergeFields = React.useMemo(() => {
    const fields: MergeFieldData[] = (data?.result?.mergeFields || []).map((mf: MergeFieldData) => ({ ...mf }));
    return fields.sort(sortMergeFieldsByCategory);
  }, [data?.result?.mergeFields]);

  return { mergeFields, loading };
};
